import { API_ROOT } from "../constants/constants";
import { getAccessToken } from "../utils/okta-config";
import { toast } from "react-toastify";
import { log } from "../Helper";
import dayjs from "dayjs";

export async function getShipToDetails(comar, serial) {
  let result = [];
  try {
    let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/controlTower?comar=${comar}&&serial=${serial}`;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };
    const response = await fetch(url, requestOptions);
    log("response", response); // log the response
    if (response.status === 204) {
      log("response status 204", response);
      toast.error("No data found for the given comar or serial number");
      return null;
    }
    result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
}

export async function getSubDealerDetails(selected) {
  let result = [];
  try {
    let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/subDealerDetails/${selected}`;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };
    const response = await fetch(url, requestOptions);
    if (response.status === 200) {
      result = await response.json();
    }
    return result;
  } catch (error) {
    console.log(error);
  }
}

export async function PostAddressControlTowerChanges(requestDTO) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/updateShipToDetails`;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(requestDTO),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await fetch(url, requestOptions);

    // Parse the response body
    const data = await response.json(); // Use .json() to parse JSON response

    return { status: response.status, data }; // Return both status and parsed data
  } catch (error) {
    throw error; // Re-throw the error for the caller to handle
  }
}

export async function PostShipHoldDetails(requestDTO) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/saveShipHoldDetails`;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(requestDTO),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(url, requestOptions);
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  return { status: response.status, data };
}

export async function PostUrgentDetails(requestDTO) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/updateUrgentStatus`;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(requestDTO),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(url, requestOptions);
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  return { status: response.status, data };
}

export async function updateFOMStatusAPI(
  serialNumber17,
  orderPathId,
  buildId,
  status,
  addTime,
  atdFOM,
  loadBuildDateFom
,orderUnit,orderNumber) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/updateFOMOrderStatusAndDates`;
  const requestBody = {
    serialNumber17, // Include serialNumber17 in the body
    orderPathId, // Include orderPathId in the body
    buildId: buildId == 0 ? null : buildId, // Include buildId in the body
    status, // Include status in the body
    addTime: addTime ? dayjs(addTime).format("YYYY-MM-DDTHH:mm") : null, // Include addTime in the body
    orderUnit,   // Include orderUnit in the body
    orderNumber, // Include orderNumber in the body
    atdFOM, // Include ATD_FOM in the body
    loadBuildDateFom: loadBuildDateFom
      ? dayjs(loadBuildDateFom).format("YYYY-MM-DDTHH:mm")
      : null,
  };

  const requestOptions = {
    method: "POST",
    body: JSON.stringify(requestBody), // Use the requestBody object
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await fetch(url, requestOptions);

    // Parse the response body
    const data = await response.json(); // Use .json() to parse JSON response

    return { status: response.status, data }; // Return both status and parsed data
  } catch (error) {
    throw error; // Re-throw the error for the caller to handle
  }
}

export async function updateOrderPathTranposrtData(transportObj) {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/updateOrderPathTransportData`;

  const requestOptions = {
    method: "POST",
    body: JSON.stringify(transportObj),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(url, requestOptions);
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  return { status: response.status, data };
}

export async function getAuditDetails(orderPathId) {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/getAuditDetails`;

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({ orderPathId }), // 👈 sends as form data
  };

  const response = await fetch(url, requestOptions);
  const text = await response.text();

  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch (error) {
    console.error("JSON parse error:", error);
  }

  return { status: response.status, data };
}

export async function getDocuments(orderPathId) {
  try {
    const url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/documents?orderPathId=${orderPathId}`;
    
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };

    const response = await fetch(url, requestOptions);
    const text = await response.text();
    
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (error) {
      console.error("JSON parse error:", error);
    }

    return { status: response.status, data };
  } catch (error) {
    console.error('Error fetching documents:', error);
    throw error;
  }
}

export async function uploadDocumentAPI(documentDetailsDto, files) {
  try {
    const formData = new FormData();
    
    // Add document details as JSON Blob (similar to other file upload APIs)
    formData.append(
      "jsonBodyData",
      new Blob([JSON.stringify(documentDetailsDto)], {
        type: "application/json",
      })
    );
    
    // Add files to FormData (support multiple files) - using same pattern as load build
    if (Array.isArray(files)) {
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
    } else {
      formData.append("file", files);
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/uploadDocument`;
    
    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        // Don't set Content-Type header - let browser set it with boundary for multipart
      },
    };

    const response = await fetch(url, requestOptions);
    const text = await response.text();
    const data = text ? JSON.parse(text) : {};

    return { status: response.status, data };
  } catch (error) {
    console.error('Error uploading document:', error);
    throw error;
  }
}

export async function deleteDocumentAPI(orderPathId, documentId, orderUnit, orderNumber, documentType) {
  try {
    const url = `${process.env.REACT_APP_API_ENDPOINT}/shipToAdjustment/deleteDocumentById`;

    // Backend now accepts all parameters
    const requestBody = {
      orderPathId: parseInt(orderPathId), // Ensure it's an integer
      documentId: parseInt(documentId),   // Ensure it's an integer
      orderUnit: orderUnit,               // Include orderUnit
      orderNumber: orderNumber,           // Include orderNumber
      documentType: documentType          // Include documentType
    };

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    };

    const response = await fetch(url, requestOptions);
    const text = await response.text(); // Get response as text first
    
    let data = {};
    
    // Try to parse as JSON first
    try {
      data = text ? JSON.parse(text) : {};
    } catch (jsonError) {
      // If JSON parsing fails, it's likely a plain text response
      // Store the plain text as the message
      data = { message: text };
    }

    return { status: response.status, data };
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
}

export async function downloadDocumentAPI(name, providerId, opId, docType) {
  let result = [];
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/document/getDocuments/name/` +
      name +
      `/providerid/` +
      providerId +
      `/op/` +
      opId +
      `/docType/` +
      docType;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        "Content-Type": "application/pdf",
      },
    };
    const response = await fetch(url, requestOptions);

    if (response.status === 200) {
      result = await response.blob();
    }

    return result;
  } catch (error) {
    console.log(error);
  }
}

